export const standardWorkflowId = '14a71deb-3807-4607-bba0-92d1b612ec97';
export const defaultStartState = 'new';
export const defaultPageSize = 10;
